// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"118":"990556b5","167":"f4c40696","174":"4e160d3c","355":"72e17bf3","415":"4d6acbeb","453":"5470d7dc","491":"a060b5a8","787":"1ed0c42c"}[chunkId] + ".chunk.js";
};